import { render } from "./HeaderAdvantageEntry.vue?vue&type=template&id=64c97985&ts=true"
import script from "./HeaderAdvantageEntry.vue?vue&type=script&lang=ts"
export * from "./HeaderAdvantageEntry.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__